import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component
({
    selector: 'public-app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit 
{
    secure : boolean;

    /**
     * @desc   - construct the public header
     * @access - public
     * @param  - router : Angular router
     * @return -
     */
    constructor
    (
        private router : Router
    )
    {
        console.log('In Header');
    }

    /**
     * @desc   - initialize public header state
     * @access - public
     * @param  -
     * @return -
     */
    ngOnInit()
    {
        this.secure = true;
    }
    
    /**
     * @desc   - navigate to citations route
     * @access - public
     * @param  -
     * @return -
     */
    gotoCitations()
    {
        console.log('citations errors');
        this.router.navigate(['/citations']);
    }
}
